import React, {Component} from "react"
import {withRouter, RouteComponentProps} from "react-router-dom"
import {LandingContainer} from "../landing-container/landing-container";
import Feedback from "../landing-content/feedback";
import {Helmet} from "react-helmet";
import evanLogo from "../img/EVAN_logo_square.png";
import independentCameras1 from "../img/evan/Independent cameras_1.png";
import independentCameras2 from "../img/evan/Independent cameras_2.png";
import dependentCameras1 from "../img/evan/Dependent cameras_1.png";
import dependentCameras2 from "../img/evan/Dependent cameras_2.png";
import './evan.css';


interface EvanProps extends RouteComponentProps {}

export class Evan extends Component<EvanProps> {
    render() {
        return (
            <>
                <Helmet>
                    <title>EVAN - Event Analytics для выставок, музеев и торговых площадок | Тепловые карты и tracking посетителей</title>
                    <meta name="description" content="EVAN - система аналитики посетителей для выставок, музеев и торговых площадок. Тепловые карты зон, tracking пути посетителей, метрики по стендам, анализ популярности маршрутов и event-аналитика в реальном времени."/>
                    <meta name="keywords" content="аналитика выставок, аналитика музеев, event analytics, тепловые карты посетителей, tracking посетителей, анализ трафика, метрики стендов, анализ мероприятий, event-аналитика, торговые площади, аналитика посетителей"/>

                    {/* Open Graph */}
                    <meta property="og:title" content="EVAN - Event Analytics для выставок, музеев и торговых площадок"/>
                    <meta property="og:description" content="Система аналитики посетителей с тепловыми картами, tracking путей и метриками по стендам."/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content="https://www.labrahub.ru/#/evan"/>
                    <meta property="og:image" content="https://www.labrahub.ru/images/logos/EVAN_logo.png"/>

                    {/* Twitter Card */}
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:title" content="EVAN - Event Analytics для выставок и музеев"/>
                    <meta name="twitter:description" content="Тепловые карты посетителей, tracking путей и метрики по стендам"/>
                    <meta name="twitter:image" content="https://www.labrahub.ru/images/logos/EVAN_logo.png"/>
                </Helmet>
                <LandingContainer titleText={"EVAN — Event Analytics для выставок, музеев и торговых площадок"} titleStyle={{'fontSize': 'xx-large'}}>
                <div className="landing-section">
                    <div id="form-content" className="landing-section-content">
                        <div>
                            <img src={evanLogo} style={{width: 400}}/>
                            <p style={{ fontSize: 'xxx-large', fontWeight: 'bold' }}>EVAN.</p>
                            <p style={{ fontSize: 'x-large', fontWeight: 'bold' }}>Event analysis</p>
                            <p style={{ fontWeight: 'bold' }}>Event-аналитика (аналитика мероприятий)</p>
                        </div>
                        <div>
                            <h4 style={{ fontWeight: 'bold', marginTop: 100, marginBottom: 30 }}>
                                Какие метрики может помочь снять и проанализировать EVAN на Вашем мероприятии, выставке,
                                музее?
                            </h4>
                            <ul>
                                <li>Тепловая карта посещений помещений</li>
                                <li>Путь каждого уникального посетителя</li>
                                <li>Метрики по стендам</li>
                                <li>Метрики по времени у стендов и времени в целом</li>
                                <li>Сколько посетителей прошло</li>
                                <li>Общая статистика (сколько посетителей в минуту)</li>
                                <li>Наиболее/наименее популярный стенд</li>
                                <li>Наиболее популярный маршрут</li>
                                <li>Безопасные зоны вокруг объектов – охранительная функция и т.д.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="landing-section">
                    <div className="landing-section-content">
                        <div className="cameras-section">
                            <p>Независимые камеры</p>
                            <img style={{ maxWidth: '70%' }} src={independentCameras2}/>
                            <img style={{ maxWidth: '70%' }} src={independentCameras1}/>
                        </div>
                    </div>
                </div>
                <div className="landing-section">
                    <div className="landing-section-content">
                        <div className="cameras-section">
                            <p>Зависимые камеры</p>
                            <img src={dependentCameras2}/>
                            <img src={dependentCameras1}/>
                        </div>
                    </div>
                </div>
            </LandingContainer>
            </>
        )
    };
}

export default withRouter(Evan)
